import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { ISetOutfit } from "../../../models/interactions/SetOutfit";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import SetOutfitPreviewBody from "./SetOutfitPreviewBody";

export default function SetOutfitPreview() {
  const interaction = useSelector(selectSelectedElement) as ISetOutfit;

  return (
    <PiPopupWindowPreview
      header={<PiPopupHeaderBar interactionType={interaction.type} title="Set Outfit" />}
      body={<SetOutfitPreviewBody />}
      size="hug"
    />
  );
}
